import { render, staticRenderFns } from "./BlobViewer.vue?vue&type=template&id=03827be6&scoped=true"
import script from "./BlobViewer.vue?vue&type=script&lang=js"
export * from "./BlobViewer.vue?vue&type=script&lang=js"
import style0 from "./BlobViewer.vue?vue&type=style&index=0&id=03827be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03827be6",
  null
  
)

export default component.exports